export enum MyCollectionTestIds {
  LOADER = 'my-coll-loader',
  EMPTY = 'my-coll-empty',
  ASSETS = 'my-coll-assets'
}
